import ConfigService from "./config-service";
import ePharmaServices from "./epharma-services";
import keys from "../util/keys";
import { ICouponRequest } from "../interfaces/coupon";

class CouponBuilderService {

    static getBenefits = async () =>
    {
        const baseUrl = window.eurofarmaService.base;
        const benefitUrl = await ConfigService().getConfig(keys.EndpointEurofarmaBenefit);

        const response = await ePharmaServices(baseUrl).get(benefitUrl);

        return response.data;
    }

    static generateCoupons = async (request: ICouponRequest) =>
    {
        const baseUrl = window.eurofarmaService.base;
        const generateCouponUrl = await ConfigService().getConfig(keys.EndpointEurofarmaGenerateCoupon);

        const response = await ePharmaServices(baseUrl).post(`${generateCouponUrl}`, request);

        return response.data;
    }
}
    export default CouponBuilderService;
